'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by zfc on 2017/6/15.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('components');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AlipaySuccessPage = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(AlipaySuccessPage, _Component);

  function AlipaySuccessPage() {
    (0, _classCallCheck3.default)(this, AlipaySuccessPage);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(AlipaySuccessPage).call(this));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(AlipaySuccessPage, [{
    key: 'render',
    value: function render() {
      var params = this.props.params;

      var urlAdress = '/personalcenter/personalbuying/productpreselection';
      if (params.activeId === 'M001538') {
        urlAdress = '/orderlist/';
      } else if (params.activeId === 'M001794') {
        urlAdress = '/serviceorderlist/';
      }
      var styles = require('./AlipaySuccessPage.scss');
      return _react2.default.createElement(
        _components.WarningPage,
        { text: '订单支付成功' },
        _react2.default.createElement(
          'div',
          { style: { width: '100%', padding: '0px 35%' } },
          _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.submittedSucesBtn
              // + data.orderNumber
              , to: urlAdress },
            '查看订单'
          ),
          _react2.default.createElement(
            _reactRouter.Link,
            { className: styles.submittedSucesBtn,
              to: '/' },
            '继续购买'
          )
        )
      );
    }
  }]);
  return AlipaySuccessPage;
}(_react.Component), _class.propTypes = {
  params: _react.PropTypes.object,
  location: _react.PropTypes.object
}, _temp);
exports.default = AlipaySuccessPage;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/AlipaySuccessPage/AlipaySuccessPage.js
 ** module id = 1436
 ** module chunks = 0
 **/